import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { GoClock, GoTrash } from 'react-icons/go';
import { LoadingSkeleton } from '../../components/LoadingSkeleton';
import { SERVICE_PERIODS_MAX_PER_DAY, WEEK_DAY_NAMES, copyDefaultPeriods } from '../../utilities/serviceDays';

// Aba "Dias de atendimento" do cadastro do doutor: um interruptor por dia e os horários de cada dia ligado.
// O estado fica na página (como a assinatura) e vai no mesmo Salvar do cadastro
const TabServiceDays = ({ serviceDays, setServiceDays, loading }) => {
  if (loading) return <LoadingSkeleton />;

  // A carga do doutor falhou: sem os dias salvos, a aba avisa e o Salvar não mexe neles
  if (!serviceDays) return <small className='text-danger'>Não foi possível carregar os dias de atendimento. Recarregue a página.</small>;

  const changeDay = (weekDay, change) => setServiceDays((days) => days.map((day) => (day.week_day === weekDay ? { ...day, ...change(day) } : day)));

  // Desligar só esconde os horários: religado antes de salvar, o dia volta como estava
  const toggleDay = (weekDay, activated) => changeDay(weekDay, (day) => ({ activated, periods: day.periods.length > 0 ? day.periods : copyDefaultPeriods() }));
  const changePeriod = (weekDay, index, field, value) => changeDay(weekDay, (day) => ({ periods: day.periods.map((period, i) => (i === index ? { ...period, [field]: value } : period)) }));
  const addPeriod = (weekDay) => changeDay(weekDay, (day) => ({ periods: [...day.periods, { start_time: '', end_time: '' }] }));
  const removePeriod = (weekDay, index) => changeDay(weekDay, (day) => ({ periods: day.periods.filter((_, i) => i !== index) }));

  return (
    <>
      <h6 className='fw-semibold mb-1'>Dias de atendimento</h6>
      <small className='text-muted d-block mb-2'>Ligue os dias em que o doutor atende e informe os horários. A agenda só aceita agendamentos dentro deles.</small>

      {serviceDays.map((day) => {
        const name = WEEK_DAY_NAMES[day.week_day];

        return (
          <div key={day.week_day} className='py-2 border-bottom'>
            <Form.Check
              type='switch'
              id={`service-day-${day.week_day}`}
              checked={day.activated}
              onChange={(e) => toggleDay(day.week_day, e.target.checked)}
              label={<span className={day.activated ? 'fw-semibold' : 'text-muted'}>{name}</span>}
            />

            {day.activated ? (
              <div className='ms-4 mt-2 d-grid gap-2'>
                {day.periods.map((period, index) => (
                  <div key={index} className='d-flex align-items-center gap-2 flex-wrap'>
                    <Form.Control
                      size='sm'
                      type='time'
                      value={period.start_time}
                      style={{ maxWidth: 130 }}
                      aria-label={`Início do horário ${index + 1} de ${name}`}
                      onChange={(e) => changePeriod(day.week_day, index, 'start_time', e.target.value)}
                    />
                    <span className='text-muted small'>até</span>
                    <Form.Control
                      size='sm'
                      type='time'
                      value={period.end_time}
                      style={{ maxWidth: 130 }}
                      aria-label={`Fim do horário ${index + 1} de ${name}`}
                      onChange={(e) => changePeriod(day.week_day, index, 'end_time', e.target.value)}
                    />
                    {day.periods.length > 1 ? (
                      <Button
                        type='button'
                        variant='outline-danger'
                        size='sm'
                        className='m-0 p-0 px-2'
                        title='Remover horário'
                        aria-label={`Remover o horário ${index + 1} de ${name}`}
                        onClick={() => removePeriod(day.week_day, index)}
                      >
                        <GoTrash />
                      </Button>
                    ) : ''}
                  </div>
                ))}

                {day.periods.length < SERVICE_PERIODS_MAX_PER_DAY ? (
                  <div>
                    <Button
                      type='button'
                      variant='link'
                      size='sm'
                      className='p-0 text-decoration-none d-inline-flex align-items-center gap-1'
                      onClick={() => addPeriod(day.week_day)}
                    >
                      <GoClock /> Adicionar horário
                    </Button>
                  </div>
                ) : ''}
              </div>
            ) : ''}
          </div>
        );
      })}
    </>
  );
};

export default TabServiceDays;
